'use client'

import React from 'react'
import { createGlobalStyle } from 'styled-components'
import StyledDotsContainer from './StyledDotsContainer/StyledDotsContainer'
import StyledDot from './StyledDot/StyledDot'
import { DotsProps } from './type'
import { dotsKeyframes } from './style'

// Global style to include the animation keyframes
const GlobalStyle = createGlobalStyle`
    ${dotsKeyframes}
`

/**
 * Loading indicator component that displays three animated dots
 */
const Dots: React.FC<DotsProps> = ({
    variant = 'dark',
    size = 'medium',
    speed = 'normal',
    color,
    className = '',
    dataTestId
}) => {
    return (
        <>
            <GlobalStyle />
            <StyledDotsContainer className={className} data-testid={dataTestId}>
                <StyledDot
                    variant={variant}
                    size={size}
                    speed={speed}
                    color={color}
                    className='dot dot1'
                />
                <StyledDot
                    variant={variant}
                    size={size}
                    speed={speed}
                    color={color}
                    className='dot dot2'
                />
                <StyledDot
                    variant={variant}
                    size={size}
                    speed={speed}
                    color={color}
                    className='dot dot3'
                />
            </StyledDotsContainer>
        </>
    )
}

export default Dots
